import { render } from "./index.vue?vue&type=template&id=12ebb549&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=12ebb549&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=12ebb549&lang=less&scoped=true"

import exportComponent from "/root/workspace/service-web_SY5C/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ebb549"]])

export default __exports__